RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    views.SearchFilterCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'metric-table-cell',
        template: '#socialPostsSearchFilterCellTemplate',

        getPathParams: function (data) {
            const me = this;

            const dimensions = _.zipObject(me.model.getFreeDimensions(), _.dropRight(data));
            return _.pick(_.defaults(dimensions, me.model.attributes), App.utils.validCurationOptions);
        },

        templateHelpers: function () {
            const me = this;
            const data = me.getOption('data');

            const params = me.getPathParams(data);

            const child = {};
            // Set the relevant dimension to undefined to get the correct name
            child[me.model.get('dimension')] = undefined;
            const metric = me.model.build(child);

            return _.extend({
                name: metric.format(data[0]),
                isSummaryRow: data[0] === '__SUMMARY_ROW__',
                hidePostsUrl: Boolean(me.model.get('hidePostsUrl')),
                postsUrl: function () {

                    return RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(
                        RivalIQ.enums.curation.SOCIALPOSTS,
                        _.extend({
                            limit: -1,
                            instanceId: 'social-posts'
                        }, params)
                    );
                },
                executeSearchUrl: function () {
                    return RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(
                        RivalIQ.enums.curation.SOCIALPOSTS,
                        params
                    );
                }
            }, RivalIQ.utils.emoji.getTemplateHelpers());
        }
    });

    views.HashtagNameCell = views.SearchFilterCell.extend({

        getPathParams: function (data) {
            const me = this;

            const params = App.views.SearchFilterCell.prototype.getPathParams.call(me, data);
            const hashtag = `#${_.last(data)}`;

            let searchTerm = params.searchTerm || '';

            const terms = searchTerm.split(/\s+/);
            const newTerm = hashtag.toLowerCase();

            const exists = Boolean(_.find(terms, function (term) {
                return term.toLowerCase() === newTerm;
            }));

            if (!exists) {
                searchTerm = [searchTerm, hashtag]
                    .map(_.trim)
                    .join(' ');
            }

            params.searchTerm = _.trim(searchTerm);

            return params;
        }
    });

    views.CompanyLinkFilterCell = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'company-rank',
        template: '#companyLinkCellTemplate',

        serializeData: function () {
            const me = this;

            const companyId = _.head(me.getOption('data'));
            const company = RivalIQ.state.landscape.getCompanyById(companyId);

            return _.extend({
                companyName: company.get('name'),
                href: `/company/${companyId}`,
                icon_url: company.getIcon(),
                index: me.options.index,
                isFocus: (company.id === me.options.props.focusCompanyId)
            }, company.toJSON());
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    views.DomainCell = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#domainCellTemplate',

        serializeData: function () {
            const me = this;

            return {
                domain: me.getOption('data')[0]
            };
        }
    });
});
